import React, { Fragment, useState } from 'react';

import { Box, Button, Divider, Grid, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

const DestinationProductsDialog = ({ type, destinationsList, destinationProducts }) => {
    const [open, setOpen] = useState(false);

    const onClose = () => setOpen(false);

    return (
        <>
            <Tooltip title="Zobacz szczegóły">
                <Box onClick={ () => setOpen(true) } sx={ { display: 'inline-block' } }>
                    <Stack direction="row" alignItems="center" gap={ 1 }
                           sx={ { cursor: 'pointer' } }>
                        <InfoIcon fontSize="small" color="primary"/>
                        <Typography fontWeight={ 600 } variant="body2">Zobacz szczegóły</Typography>
                    </Stack>
                </Box>
            </Tooltip>

            <Dialog PaperProps={ { sx: { maxHeight: 800 } } } open={ open } onClose={ onClose } fullWidth maxWidth="md">
                <DialogTitle sx={ { fontWeight: 600, pb: 1 } }>{ type || 'Szczegóły' }</DialogTitle>
                <Divider/>

                <DialogContent sx={ { py: 3 } }>
                    <Stack spacing={ 4 }>
                        {
                            destinationsList?.map((destination, index) => {
                                if (!destinationProducts[index] || destinationProducts[index].length === 0) {
                                    return <Fragment key={ index }></Fragment>;
                                }

                                return (
                                    <Box key={ index }>
                                        <Grid container justifyContent="space-between" alignItems="flex-end"
                                              sx={ { mb: 2 } }>
                                            <Grid item>
                                                <Typography variant="h6"
                                                            sx={ { fontWeight: 600 } }>
                                                    { destination?.name }
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="subtitle2" color="text.secondary">
                                                    Suma: <Box component="span" sx={ {
                                                    fontWeight: 600,
                                                    color: 'text.primary'
                                                } }>{ destinationProducts[index]?.reduce((accumulator, current) => accumulator + current?.quantity, 0) } szt.</Box>
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <TableContainer component={ Paper } variant="outlined">
                                            <Table stickyHeader size="small">
                                                <TableHead>
                                                    <TableRow sx={ {
                                                        '& th': {
                                                            backgroundColor: 'slate.50',
                                                            fontWeight: 600
                                                        }
                                                    } }>
                                                        <TableCell>Nazwa produktu</TableCell>
                                                        <TableCell align="center" style={ { width: '15%' } }>Liczba
                                                            szt.</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        destinationProducts[index]?.map((product, productIndex) => (
                                                            <TableRow key={ productIndex } hover>
                                                                <TableCell sx={ { fontWeight: 500 } }>
                                                                    { product?.name }
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    { product?.quantity }
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                );
                            })
                        }
                    </Stack>
                </DialogContent>

                <Divider sx={ { mt: 1 } }/>

                <DialogActions sx={ { px: 3, py: 2 } }>
                    <Button onClick={ onClose } variant="outlined">Zamknij</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DestinationProductsDialog;